import axios from "axios";
const BASE_URL="http://localhost:3500";
const AUTH_SERVICE_URL = 'https://cooksp3-001-site1.mtempurl.com';
const ADMIN_SERVICE_URL="https://cooksp3-001-site2.mtempurl.com";

export default axios.create({
    baseURL: BASE_URL
});
export const axiosPrivate=axios.create({
    baseURL:BASE_URL,
    headers:{ "Content-Type":"application/json"},
    withCredentials:true,
});
export const authService=axios.create({
    baseURL:AUTH_SERVICE_URL,
    headers:{ "Content-Type":"application/json"},
    withCredentials:true,
});
export const adminService=axios.create({
    baseURL:ADMIN_SERVICE_URL,
    headers:{ "Content-Type":"application/json"},
    withCredentials:true,
});